export const criminalRecordTypeCatalog: Record<string, { urlCheck: string }> = {
  'Compliance Criminal': {
    urlCheck: 'https://antecedentes.dpf.gov.br/antecedentes-criminais/certidao'
  }
}
